<template>

  <div
      class="global-search"
      :class="[
      props.params.class,
      { '!w-full': !isAdmin }
    ]"
  >
    <Input
        ref="inp"
        @keydown.enter="goToSearchPage"
        v-model="searchText"
        id="searchInput"
        class="field global-search__field !w-full !mb-0"
        type="text"
        :placeholder="$t('search.placeholder')"
    />
  </div>
</template>


<script setup>
import {ref, defineProps, watch, onMounted, computed } from "vue";
import { useRouter } from 'vue-router'
import {useStore} from "vuex";
import {useI18n} from "vue-i18n";
import Input from "@/components/UI/inputs/Input.vue";

const {t} = useI18n()
const router = useRouter()
const isAdmin = computed(() => store.state.auth.isAdmin)
const goToSearchPage = () => {
  findItems()
  router.push({ path: '/search' })
}
const props = defineProps({
    params: {
        type: Object,
        required: false,
        default: () => {
            return {}
        }
    }
})
const store = useStore()
const searchText = ref("");
const inp = ref(null);
// const filters = [
//      {
//          icon: '',
//          name: 'Все',
//          key: 'all'
//     },
//     {
//         icon: '/img/sprites/icons-sprite.svg#icon-course',
//         name: 'Курсы',
//         key: 'courses'
//     },
//     {
//         icon: '/img/sprites/icons-sprite.svg#icon-man',
//         name: 'Люди',
//         key: 'users'
//     },
    // {
    //     icon: '/img/sprites/icons-sprite.svg#icon-data',
    //     name: 'Файлы',
    //     key: 'files'
    // }
// ]
// const activeFilter = ref(filters[0])
// const changeFilter = filter => {
//     activeFilter.value = filter
//     findItems()
// }


const findItems = () => {
  if (!searchText.value.trim()) return;

  store.commit('setSearchState', true);
  store.commit('setCoursePagination', 0);

  store.commit('setFindedUsers', []);
  //store.commit('setFindedFiles', []);

  if (store.state.auth.isAdmin) {
    store.dispatch('getRelevantUsers', searchText.value)
  }

  store.dispatch('searchCourses', {
    query: searchText.value,
    page: 0
  });
}
</script>

<style lang="scss" scoped>
@import './scss/global-search.scss';
</style>
